const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',

	/** @description Initialize */
	init: function() {
		this.headerSticky();
		$(document).on('scroll', this.headerSticky.bind(this));
		$(window).on('load', this.headerSticky.bind(this));
	},

	headerSticky: function() {
		const scrollTop = $(document).scrollTop();
		this.$domHeader.toggleClass(this.classHeaderScroll, scrollTop > 20);
	},
};

export default Header;
